import { API_BASE, apiSlice } from '@/redux/api-slice'
import { mapLocalToServer, mapServerToLocal } from './mapSearchSettings'
import type { UserSearchPreferences } from './types'

const url = API_BASE + 'user'

export const userPreferencesApi = apiSlice
  .enhanceEndpoints({ addTagTypes: ['SearchSettings'] })
  .injectEndpoints({
    endpoints: (build) => ({
      getUserSearchPreferences: build.query<UserSearchPreferences | null, void>(
        {
          query: () => ({
            url: `${url}/searchDisplaySettings`,
          }),
          transformResponse: mapServerToLocal,
        },
      ),

      setUserSearchPreferences: build.mutation<void, UserSearchPreferences>({
        query: (searchPreferences: UserSearchPreferences) => ({
          method: 'post',
          url: `${url}/searchDisplaySettings`,
          body: mapLocalToServer(searchPreferences),
        }),

        // Optimistic update, don't revert on error
        async onQueryStarted(arg, api) {
          api.dispatch(
            userPreferencesApi.util.updateQueryData(
              'getUserSearchPreferences',
              undefined,
              (draft) => {
                if (draft) {
                  Object.assign(draft, arg)
                } else {
                  return arg
                }
              },
            ),
          )

          try {
            await api.queryFulfilled
          } catch (e) {
            console.error(e)
          }
        },
      }),
    }),
  })

export const {
  useGetUserSearchPreferencesQuery,
  useLazyGetUserSearchPreferencesQuery,
  useSetUserSearchPreferencesMutation,
} = userPreferencesApi
